import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import HelpWizardPanel from '../features/playerHelpWizard/HelpWizardPanel';
import { useHelpWizardOptional } from '../features/playerHelpWizard/HelpWizardProvider';
import { authAPI } from '../services/api';

/** Route page: /player/help */
export default function PlayerHelpWizardPage() {
  const wizard = useHelpWizardOptional();

  useEffect(() => {
    wizard?.startOver?.();
    // Reset flow when opening Help from the sidebar (fresh visit to this route).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: featureRes, isLoading } = useQuery(
    ['player-help-wizard-feature'],
    () => authAPI.getPlayerHelpWizardFeature(),
    { staleTime: 60 * 1000, retry: 1 }
  );

  const enabled = featureRes?.data?.enabled === true;
  const nodeId = wizard?.nodeId;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [nodeId]);

  if (isLoading) {
    return null;
  }

  if (!enabled) {
    return <Navigate to="/player" replace />;
  }

  return <HelpWizardPanel />;
}
